const accordeonItems = document.querySelectorAll(".accordeon-item");

[].forEach.call(accordeonItems, (accordeonItemEl) => {
  const accordeonItemHash = "#" + accordeonItemEl.id;
  const pageHash = window.location.hash;

  if (accordeonItemHash === pageHash) {
    accordeonItemEl.classList.add("active");
  }

  const headingEl = accordeonItemEl.querySelector(".accordeon-item__heading");
  headingEl.addEventListener("click", function () {
    accordeonItemEl.classList.toggle("active");
  });
});
